import { Country, State } from '../../../src/Definitions/CountryState';
export const actions = {
    setCountries( countries: Country[] ) {
        return {
            type: 'SET_COUNTRIES',
            countries,
        };
    },

    setStatesForCountry( countryCode: string, states: State[] ) {
        return {
            type: 'SET_STATES',
            countryCode,
            states,
        };
    },

    setError( selector: string, error: string ) {
        return {
            type: 'SET_ERROR',
            selector,
            error,
        };
    },

    startResolution( selector: string ) {
        return {
            type: 'START_RESOLUTION',
            selector,
        };
    },

    finishResolution( selector: string ) {
        return {
            type: 'FINISH_RESOLUTION',
            selector,
        };
    },
};
